import { useCallback, useState } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import CatBrowse from "./components/CatBrowse";
import TodayFeed from "./components/TodayFeed";
import HotRank from "./components/HotRank";
import Community from "./components/Community";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

export default function Home() {
  const [cat, setCat] = useState("全部");
  const [query, setQuery] = useState("");

  const applyCat = useCallback((c: string) => {
    setCat(c);
    setQuery("");
    requestAnimationFrame(() => {
      document.getElementById("today")?.scrollIntoView({ behavior: "smooth" });
    });
  }, []);

  const goRead = useCallback(() => {
    // 当前为速查入口形态，点击卡片定位到该分类的信息流；后续扩展详情页时替换为跳转 /article/:id
    setQuery("");
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Header query={query} setQuery={setQuery} onPick={() => document.getElementById("today")?.scrollIntoView({ behavior: "smooth" })} />
      <main>
        <Hero onCat={applyCat} />
        <CatBrowse onCat={applyCat} />
        <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
          <TodayFeed cat={cat} onCat={setCat} query={query} goRead={goRead} />
          <div className="pb-10 md:pb-14">
            <HotRank />
          </div>
        </div>
        <Community />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}